module.exports = __webpack_public_path__ + "img/stendhal.7edcd750.jpg";